
import { Button } from "@/components/ui/button";
import { Lightbulb } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

export function FreeForeverSection() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  return (
    <section className="py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container max-w-4xl text-center px-4">
        <div className="bg-primary/10 p-4 rounded-lg w-fit mx-auto mb-6">
          <Lightbulb className="h-8 w-8 text-primary" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4">Start Your Subscription Today</h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Hour Tracker provides all the tools you need for time tracking, project management, and invoice generation. Choose your plan and get started now.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size={isMobile ? "lg" : "default"} 
            onClick={() => navigate("/auth?mode=signup")}
            className="w-full"
          >
            Start Subscription
          </Button>
          <Button 
            size={isMobile ? "lg" : "default"} 
            variant="outline" 
            onClick={() => navigate("/learn-more")}
            className="w-full"
          >
            Learn More
          </Button>
        </div>
        <p className="text-sm text-muted-foreground mt-4">
          Professional time tracking and invoicing • Cancel anytime
        </p>
      </div>
    </section>
  );
}
